import { render, staticRenderFns } from "./MRSimple.vue?vue&type=template&id=0f61022c&"
import script from "./MRSimple.vue?vue&type=script&lang=js&"
export * from "./MRSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports